import { DropdownMenuItem } from '@repo/ui/dropdownMenu'
import { SkullIcon } from 'lucide-react'

import { sudoStoreActions } from '@/store/actions'
import { useStoreDispatch } from '@/store/hooks'

export function OrganizationTerminator({ organizationId }: { organizationId: string }) {
  const dispatch = useStoreDispatch()
  const hardDeleteOrganization = (organizationId: string) => {
    void dispatch(
      sudoStoreActions.organization.hardDeleteOne({
        organizationId,
      }),
    )
  }
  return (
    <DropdownMenuItem
      style={{ color: 'red' }}
      isSensitive
      onClick={() => hardDeleteOrganization(organizationId)}
    >
      <SkullIcon className="size-4" />
      Delete Organization (HARD DELETE)
    </DropdownMenuItem>
  )
}
